@if (deviceInfo$ | async; as deviceInfo) {
  <div
    [wlBackground]="backgroundSettings"
    [wlAutomationId]="'dynamic-row-background'"
  >
    <!-- container and row -->
    <div
      [ngClass]="['container', settings?.paddingContainer]"
      wlAutomationId="main-content"
    >
      @switch (brand) {
        @case ('ed') {
          <wl-partial-structured-content
            [layoutButtonsInline]="true"
            [centered]="true"
            [theme]="contentTheme"
          >
            @if (content?.heading?.text?.value) {
              <ng-container slot="heading">
                <h3
                  class="h3 h1-md row-heading"
                  *scText="content.heading.text"
                ></h3>
              </ng-container>
            }
            @if (content?.text?.text?.value) {
              <ng-container slot="subheading">
                <h4
                  class="intro row-subheading"
                  *wlGenericRichText="content.text.text"
                ></h4>
              </ng-container>
            }

            <ng-container slot="content">
              <div
                ngProjectAs="content"
                class="row"
                [ngClass]="[
                  settings?.paddingRow,
                  settings?.columnJustification,
                ]"
                [wlAutomationId]="'dynamic-row-row'"
              >
                @for (
                  columnConfig of settings?.columnConfigs;
                  track columnConfig;
                  let i = $index
                ) {
                  @if (!hideOnMobile(deviceInfo, columnConfig)) {
                    <ng-template
                      *ngTemplateOutlet="
                        column;
                        context: {
                          $implicit: columnConfig,
                          index: i,
                          isMobile: deviceInfo.isMobile,
                          lastElement: settings?.columnConfigs.length - 1 === i,
                          backgroundClass: backgroundSettings?.backgroundClass,
                        }
                      "
                    ></ng-template>
                  }
                }
              </div>
            </ng-container>

            @if (content?.buttons?.primary?.link?.href) {
              <ng-container slot="button-primary">
                <wl-partial-button
                  role="link"
                  [theme]="primaryButtonTheme"
                  [fullWidth]="true"
                  [context]="settings.context"
                  [ngClass]="content.buttons.primary.link.class"
                  [href]="content.buttons.primary.link.href"
                  [target]="content.buttons.primary.link.target || '_self'"
                  [wlTrackLink]="content.buttons.primary.link.text"
                  [trackLinkInfo]="{
                    rendering: rendering,
                    field: content.buttons.primary.link.text,
                    eventType: 'button-click',
                  }"
                >
                  {{ content.buttons.primary.link.text }}
                </wl-partial-button>
              </ng-container>
            }
            @if (content?.buttons?.secondary?.link?.href) {
              <ng-container slot="button-secondary">
                <wl-partial-button
                  role="link"
                  theme="tertiary"
                  size="small"
                  [fullWidth]="true"
                  [ngClass]="content.buttons.secondary.link.class"
                  [href]="content.buttons.secondary.link.href"
                  [target]="content.buttons.secondary.link.target || '_self'"
                  [wlTrackLink]="content.buttons.secondary.link.text"
                  [trackLinkInfo]="{
                    rendering: rendering,
                    field: content.buttons.secondary.link.text,
                    eventType: 'button-click',
                  }"
                >
                  {{ content.buttons.secondary.link.text }}
                </wl-partial-button>
              </ng-container>
            }
          </wl-partial-structured-content>
        }
        @default {
          <wl-basic-content variant="ngContentBetween" [content]="content">
            <div
              [class.mt-2]="
                content?.heading?.text?.value ||
                content?.subheading?.text?.value
              "
              class="row"
              [ngClass]="[settings?.paddingRow, settings?.columnJustification]"
              [wlAutomationId]="'dynamic-row-row'"
            >
              @for (
                columnConfig of settings?.columnConfigs;
                track columnConfig;
                let i = $index
              ) {
                @if (!hideOnMobile(deviceInfo, columnConfig)) {
                  <ng-template
                    *ngTemplateOutlet="
                      column;
                      context: {
                        $implicit: columnConfig,
                        index: i,
                        isMobile: deviceInfo.isMobile,
                        lastElement: settings?.columnConfigs.length - 1 === i,
                        backgroundClass: backgroundSettings?.backgroundClass,
                      }
                    "
                  ></ng-template>
                }
              }
            </div>
          </wl-basic-content>
        }
      }
    </div>
  </div>
}

<!-- column -->
<ng-template
  #column
  let-columnConfig
  let-index="index"
  let-isMobile="isMobile"
  let-lastElement="lastElement"
  let-backgroundClass="backgroundClass"
>
  <div
    [ngClass]="[
      'col-12 col-lg-' + columnConfig.width,
      'order-lg-' + (index + 1) + ' order-' + columnConfig.orderMobile,
      columnConfig.padding || (lastElement ? '' : 'pb-2 pb-lg-0'),
    ]"
    [wlAutomationId]="'dynamic-row-column-' + (index + 1)"
  >
    @if (showPlaceholderAt(index, isXpEditorActive$ | async)) {
      <sc-placeholder
        [name]="'column-' + (index + 1)"
        [rendering]="rendering!"
        [inputs]="{
          context: {
            colWidth: columnConfig.width,
            index: index,
            containerPosition: rendering?.position,
            name: rendering?.fields?.componentName?.value,
            containerBackground: isMobile
              ? backgroundSettings?.mobile?.src
              : backgroundSettings?.desktop?.src,
            backgroundClass: backgroundClass,
          },
        }"
        (loaded)="onColumnPlaceholderLoaded($event)"
      ></sc-placeholder>
    }
  </div>
</ng-template>
